/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../nb');
var app = require('../app');
module.exports = nb.define({
    parent: app.Page,
    view: {
        'class': 'nb-page',
        $html: [
            {
                'class': 'nb-page-header',
                $type: require('./Header'),
                $model: 'header'
            },
            {
                'class': 'nb-page-content',
                $html: [{
                    $type: require('./sidebar/Sidebar'),
                    $model: 'sidebar'//sidebar
                }, {
                    'class': 'page-content',
                    $html: [{
                        $type: require('./notice/Notice'),
                        $model: 'notice'
                    }, {
                        'class': ['section', nb.bind('dataReady')],
                        style: {
                            'min-height': nb.bind('sectionMinHeight')
                        },
                        $html: [{
                            tag: 'img',
                            'class': 'loading-gif abs-center',
                            src: './image/loading.gif',
                            style: {
                                width: '70px'
                            }
                        }, {
                            'class': 'section-content',
                            style: {
                                'min-height': nb.bind('sectionMinHeight')
                            },
                            $slot: 'content'
                        }]
                    }]
                }]
            },
            {
                'class': ['content-cover opacity0 ', nb.bind('ajaxReady')]
            }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/Page.js
// module id = 35
// module chunks = 0 1 3 4 7 8 9 10 12 13 14 15 16 18 19 21 25 26 27 28 30